import {getErrorMessageHtml, getInputErrorClasses, hasFieldAnError} from "../../Utils/FormHelpers";
import {ExclamationCircleIcon} from "@heroicons/react/24/outline";
import {useTranslation} from "react-i18next";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import React, {useEffect, useState} from "react";
import {Controller} from "react-hook-form";

export const DateTimePickerInput = (props) => {
    const {
        register,
        name,
        translationIndex,
        errors,
        currentValue = null,
        setValue,
        control = null,
        dateFormat = "dd/MM/yyyy HH:mm",
        showTimeInput = true,
        isClearable = false,
        disabled = false,
        showMonthYearPicker = false
    } = props;
    const {t} = useTranslation();

    const [localCurrentValue, setLocalCurrentValue] = useState(currentValue);

    useEffect(() => {
        setLocalCurrentValue(currentValue);
    }, [currentValue]);

    return (
        <div>
            <label htmlFor={name}
                   className="block text-left text-sm font-medium text-gray-900 mb-2">
                {t(`${translationIndex}`)}
            </label>
            <div className="relative rounded-md shadow-sm w-full">

                {
                    control !== undefined && control !== null && (
                        <Controller
                            name={name}
                            control={control}
                            render={({field: {ref, ...field}, fieldState}) => (
                                <>
                                    <DatePicker
                                        {...field}
                                        ref={(instance) => {
                                            const focusable = instance ? {focus: () => instance.setFocus?.()} : null;
                                            if (typeof ref === 'function') {
                                                ref(focusable);
                                            } else if (ref) {
                                                ref.current = focusable;
                                            }
                                        }}
                                        onChange={(date) => {
                                            setValue(name, date)
                                            field.onChange(date)
                                        }}
                                        selected={field.value}
                                        dateFormat={dateFormat ?? "dd/MM/yyyy HH:mm"}
                                        timeZone="Europe/Brussels"
                                        showTimeInput={showTimeInput ?? true}
                                        className={`block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:outline-none focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6 ${disabled ? 'bg-gray-100 cursor-not-allowed opacity-60' : ''} ${getInputErrorClasses(errors, name)}`}
                                        onSelect={(date) => {
                                            setValue(name, date)
                                            field.onChange(date)
                                        }}
                                        isClearable={isClearable ?? false}
                                        disabled={disabled}
                                        showMonthYearPicker={showMonthYearPicker}
                                    />
                                </>

                            )}
                        ></Controller>
                    )
                }

                {
                    !(control !== undefined && control !== null) && (
                        <DatePicker
                            onChange={(date) => {
                                setLocalCurrentValue(date);
                                setValue(name, date);
                            }}
                            selected={localCurrentValue}
                            dateFormat={dateFormat ?? "dd/MM/yyyy HH:mm"}
                            timeZone="Europe/Brussels"
                            showTimeInput={showTimeInput ?? true}
                            className={`block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:outline-none focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6 ${disabled ? 'bg-gray-100 cursor-not-allowed opacity-60' : ''} ${getInputErrorClasses(errors, name)}`}
                            onSelect={(date) => {
                                setLocalCurrentValue(date);
                                setValue(name, date);
                            }}
                            isClearable={isClearable ?? false}
                            disabled={disabled}
                            showMonthYearPicker={showMonthYearPicker}
                        />
                    )
                }



                {
                    hasFieldAnError(errors, name) && (
                        <div
                            className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                            <ExclamationCircleIcon
                                className="h-5 w-5 text-red-500"
                                aria-hidden="true"/>
                        </div>
                    )
                }
            </div>

            {getErrorMessageHtml(errors, name)}
        </div>
    )
}